import type { AppRouteObject } from "../routes";
import { ReportsRoute, ReportsWithRoute } from "./routes/Reports";

const routes: AppRouteObject[] = [ReportsRoute, ReportsWithRoute];

export default routes;
